import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import './InputWithSelect.sass'

export function InputWithSelect (props) {
  const {
    label,
    autocorrect,
    autocomplete,
    spellcheck,
    autocapitalize,
    type = 'text',
    placeholder,
    inputName,
    value,
    disabled,
    required,
    maxLength,
    showError = true,
    errorMessage = '',
    infoMessage = '',
    onInput,
    size,
    options,
    onSelectChange,
  } = props

  const defaultOption = Array.isArray(options[0]?.items) ? options[0].items[0] : options[0]

  const [selectValue, setSelectValue] = useState(defaultOption?.value)

  useEffect(() => {
    setSelectValue({ value: options[0]?.items[0]?.value, label: options[0]?.items[0]?.label })
  }, [props.options])

  const isEmpty = !value
  const _showError = () => {
    return errorMessage && showError
  }
  const _showInfo = () => {
    return !_showError() && infoMessage
  }
  const _onBlur = () => {}
  const _onFocus = () => {}
  const _onInput = (e) => {
    if (onInput) onInput(e.target.value)
  }

  const onChange = (e) => {
    setSelectValue({ value: e.value, label: e.value })
    onSelectChange && onSelectChange(e.value)
  }

  const dropdownRef = useRef(null)

  return <div className={classNames(`domain-input ${size}`, {
    '_is-empty': isEmpty,
    '_is-invalid': _showError(),
    '_is-disabled': disabled,
    '_is-required': required,
    // '_show-error': show_error,
  })} >
    <label>{label || 'Search for the perfect domain'}</label>
    <div className='input-select-container'>
      <input
        required={required}
        disabled={disabled ? '' : null}
        name={inputName}
        type={type}
        placeholder={placeholder}
        autoComplete={autocomplete === true ? 'on' : (autocomplete || 'nope')}
        autoCorrect={autocorrect ? 'on' : 'off'}
        autoCapitalize={autocapitalize === true ? 'on' : (autocapitalize || 'off')}
        spellCheck={spellcheck}
        maxLength={maxLength || null}
        aria-label={label}
        onBlur={_onBlur}
        onFocus={_onFocus}
        onChange={_onInput}
      />
      <Dropdown ref={dropdownRef} className='dropdown' onChange={onChange} options={options} value={selectValue} placeholder="Select an option" />
      {_showInfo()
        ? <div className="input-bottom info">
          <img src="/assets/icons/info-icon.svg" />
          <span>{infoMessage}</span>
        </div>
        : ''}
      {_showError()
        ? <div className="input-bottom error">
          <img src="/assets/icons/error-icon.svg" />
          <span>{errorMessage}</span>
        </div>
        : ''
      }
    </div>
  </div>
}
